import React, { Component } from 'react';
import { withStyles, Paper, Grid, Container, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { REMOVE_TAG, UPDATE_TAG } from '../core/handlers.actions';
import TagTable from './table/tag';
import TagForm from './forms/tag';
import { ITag } from '../core/models/tag';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

const styles = (theme: any) => ({
    root: { flrexGrow: 1, paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
    paper: { padding: theme.spacing(2), textAlign: 'center' as any, color: theme.palette.text.secondary }
});

interface Props {
    classes: any;
    tags: any;
    deleteTag: (id: string) => void;
    updateTag: (data: any) => void;
}

interface State {
    current: ITag | null;
    edit: boolean;
}

class Tags extends Component<Props, State> {
    state: State = { edit: false, current: null };

    constructor(props: Props) {
        super(props);
        this.editHandler = this.editHandler.bind(this);
        this.reset = this.reset.bind(this);
    }

    public editHandler(tag: any) {
        this.setState({ ...this.state, current: tag, edit: true });
    }
    public reset() {
        this.setState({ ...this.state, edit: false });
    }

    public render() {
        const { classes } = this.props;
        const { edit, current } = this.state;
        return (
            <Container className={classes.root}>
                <Grid container spacing={3} direction="row" justify="flex-start" >
                    <Grid item xs={12} md={4}>
                        {edit ?
                            <Paper className={classes.paper}>
                                <TagForm edit={edit} current={current} action={this.reset} />
                            </Paper>
                            :
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Button variant="contained" onClick={() => this.editHandler(null)} color="primary" startIcon={<LocalOfferIcon />}>Add Tag</Button>
                                </Grid>
                            </Grid>
                        }

                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TagTable editTag={this.editHandler} />
                    </Grid>
                </Grid>
            </Container>
        );
    }
}
const mapProps = (app: any) => ({ tags: app.rootReducer.tags });
const mapDispatch = (dispatch: Dispatch) => ({
    deleteTag: (id: string) => dispatch({ type: REMOVE_TAG, payload: id }),
    updateTag: (data: any) => dispatch({ type: UPDATE_TAG, payload: data })
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(Tags));